import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import SportGearStoragePage from '@/v2/components/pages/public-pages/sport-gear-storage-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/sport-gear-storage-page'

interface SportGearStoragePageProps {}

const Page: React.FC<SportGearStoragePageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.sport_gear_storage.title ?? ''}
        keywords={META_CONTENTS.sport_gear_storage?.keywords ?? ''}
        description={META_CONTENTS.sport_gear_storage?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />
      <SportGearStoragePage />
    </>
  )
}

export default Page
